const stickyFooterButton = () => {
	const button = document.querySelector('.mobile-fixed-bottom-button');

	const heroBlocks = document.querySelectorAll(
		'.block-hero-form, .block-hero-location-form'
	);

	if (heroBlocks.length < 1) {
		button?.classList.add('active');
		return;
	}

	const heroBoundingRect = heroBlocks[0].getBoundingClientRect();

	if (
		heroBoundingRect.bottom - window.innerHeight < 0 &&
		!button.classList.contains('active')
	) {
		button.classList.add('active');
	} else if (
		heroBoundingRect.bottom - window.innerHeight > 0 &&
		button.classList.contains('active')
	) {
		button.classList.remove('active');
	}
};

export default stickyFooterButton;
